import { client } from '../client';
import { RegisterMediaPayload } from '../communication/registersConversationMedia';
import { IGMRegisteredMedia } from '../communication/types/IGMRegisteredMedia';

export const registerAvatarMedia = async (payload: RegisterMediaPayload): Promise<IGMRegisteredMedia> => {
  const { data } = await client.post<IGMRegisteredMedia>('/media/register_upload', payload);

  return data;
};
